define('AwaLabs.CMSSegmentation', [
	'SC.Configuration',
	'Handlebars'
],
function (
	Configuration,
	Handlebars	
) {
	'use strict';

	return {
		mountToApp: function mountToApp() {
			Handlebars.registerHelper('CMSPrefix', function () {
				return Configuration.get('cms.isB2B') ? 'B2B-' : '';
			});
		}
	};
});
